import React from 'react';
// import React from 'react-native-elements';
import {Query} from 'react-apollo';
import {useQuery} from "@apollo/client";
import {GET_JOB_CARD_JOB_ROW_DATA} from "../query";
import {clientV2} from "../../../common";
import {View, Text} from "react-native";
import {Loading} from "../../../common/component";

interface IGetJobCardJobRowDataProps {
    children: (jobCard) => JSX.Element;
    jobCardId: number | string;
}

export const GetJobCardJobRowData = (props: IGetJobCardJobRowDataProps) => {
    const {data, loading, error} = useQuery(GET_JOB_CARD_JOB_ROW_DATA, {
        variables: {jobCardId: props.jobCardId.toString()},
        client: clientV2, fetchPolicy: 'network-only'
    });
    if (loading || error) return <Loading loading={loading} error={!!error?JSON.stringify(error): null}/>;
    const {getJobCard} = data;
    return props.children(getJobCard);
};